import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {Box} from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        minWidth: 100,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        fontSize: "x-small",
    },
    topTitle: {
        fontSize: "x-small",
    },
    number: {
        fontSize: "xx-large",
    },
});

export default function SimpleNumberCard(props) {
    const classes = useStyles();
    // const bull = <span className={classes.bullet}>•</span>;
    const {number = '\u00A0', title = '\u00A0', subtitle= '\u00A0', topTitle = '\u00A0', style} = props;

    return (
        <Box className={classes.root} style={style}>
            <CardContent>
                <Typography className={classes.topTitle} color="textSecondary">
                    {topTitle}
                </Typography>
                <div className={classes.number}>
                    {number}
                </div>
                <Typography className={classes.title} color="textSecondary">
                    {title}
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                    {subtitle}
                </Typography>
                {/*<Typography variant="body2" component="p">*/}
                {/*    well meaning and kindly.*/}
                {/*    <br />*/}
                {/*    {'"a benevolent smile"'}*/}
                {/*</Typography>*/}
            </CardContent>
            {/*<CardActions>*/}
            {/*    <Button size="small">Learn More</Button>*/}
            {/*</CardActions>*/}
        </Box>
    );
}
